import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {routing} from './ipd-patient-case-paper.routing';
import {IpdPatientCasePaperComponent} from './ipd-patient-case-paper.component';
import {MstVisitService} from '../configuration/mst-visit/mst-visit.service';
import {TemrVisitHistoryService} from '../configuration/temr-visit-history/temr-visit-history.service';
import {TemrVisitChiefComplaintService} from '../configuration/temr-visit-chief-complaint/temr-visit-chief-complaint.service';
import {TemrVisitSymptomService} from '../configuration/temr-visit-symptom/temr-visit-symptom.service';
import {TemrVisitNonDrugAllergyService} from '../configuration/temr-visit-non-drug-allergy/temr-visit-non-drug-allergy.service';
import {TemrVisitAllergyService} from '../configuration/temr-visit-allergy/temr-visit-allergy.service';
import {TemrDoctorsAdviceService} from '../configuration/temr-doctors-advice/temr-doctors-advice.service';
import {CpoeInvestigationService} from '../patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-investigation/cpoe-investigation.service';
import {TemrVisitPrescriptionService} from '../configuration/temr-visit-prescription/temr-visit-prescription.service';
import {TemrVisitDiagnosisService} from '../configuration/temr-visit-diagnosis/temr-visit-diagnosis.service';
import {TemrVitalService} from '../configuration/temr-vital/temr-vital.service';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';
import {TemrTimelineService} from '../configuration/temr-timeline/temr-timeline.service';
import {MstUnitService} from '../configuration/mst-unit/mst-unit.service';
import {CpoePrescriptionService} from '../patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-prescription/cpoe-prescription.service';
import {DialogModule, PanelModule, ProgressBarModule} from 'primeng/primeng';
import {CpoeDoctorAdviceService} from '../patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-doctoradvice/cpoe-doctoradvice.service';

@NgModule({
  imports: [
    CommonModule, routing, PanelModule, SharedTranslationModule, DialogModule, PanelModule, ProgressBarModule
  ],
  declarations: [IpdPatientCasePaperComponent],
  providers: [MstVisitService,
    TemrVisitHistoryService,
    TemrVisitChiefComplaintService,
    TemrVisitSymptomService,
    TemrVisitNonDrugAllergyService,
    TemrVisitAllergyService,
    TemrDoctorsAdviceService,
    CpoeInvestigationService,
    TemrVisitPrescriptionService,
    TemrVisitDiagnosisService,
    TemrTimelineService,CpoeDoctorAdviceService,
    TemrVitalService,
    MstUnitService, CpoePrescriptionService, MstVisitService,
    MstUnitService]
})
export class IpdPatientCasePaperModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd-patient-case-paper/ipd-patient-case-paper.module.ts